import { useFormatMessageDateTime } from "../components/date-label";

interface SystemMessageProps {
  text: string;
  createdAt: string | Date;
}

export function SystemMessage(props: SystemMessageProps): JSX.Element {
  const date = useFormatMessageDateTime(new Date(props.createdAt));

  return (
    <div className="w-full text-ink-muted text-xs italic mt-2 flex items-center justify-center">
      <span className="max-w-[500px] overflow-hidden text-ellipsis inline-block mr-1">
        {props.text}
      </span>
      <span>{`${date}`}</span>
    </div>
  );
}
